// extracted by mini-css-extract-plugin
export default {"lds_roller_main":"Loader_lds_roller_main__MSX9E","lds_roller":"Loader_lds_roller__OaIWn","slide-down":"Loader_slide-down__1xWzx"};